    import axios from "axios";
import {urlConfig} from "../config";

export default class ContentService {

    static getContent(cid) {

        const contentServiceInstance = axios.create({baseURL: `${urlConfig.bffUrl}/content/${cid}`, timeout: 180000});
        // const contentServiceInstance = axios.create({baseURL: `http://localhost:1339/content/${cid}`});

        return contentServiceInstance.get();
    }

}